import {useMutation, useQueryClient} from "@tanstack/react-query";

import {errorHandler} from "@/src/modules/core/lib";

import {panicAlertsService} from "../services";
import type {PanicAlertUpdatePayload} from "../types";

export function usePanicAlertUpdate() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({id, payload}: {id: number; payload: PanicAlertUpdatePayload}) =>
      panicAlertsService.patch(id, payload),
    onSuccess: (_data, variables) => {
      void queryClient.invalidateQueries({queryKey: ["panic-alert", variables.id]});
      void queryClient.invalidateQueries({queryKey: ["panic-alerts"]});
      void queryClient.invalidateQueries({queryKey: ["panic-alerts-infinite"]});
      void queryClient.invalidateQueries({queryKey: ["panic-alert-statistics"]});
    },
    onError: errorHandler,
  });
}
